import Panel from "components/shared/Panel/Panel";
import React from "react";

import { MiniTileContent, Title, Text } from "./style";

type Props = {
  title: string | number;
  text: JSX.Element | string;
};

const Tile: React.FC<Props> = ({ title, text }) => (
  <Panel isMiniTile>
    <MiniTileContent>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </MiniTileContent>
  </Panel>
);

export default Tile;
